export default __webpack_public_path__ + "static/media/play.a59ddde6.png";